module.exports = __webpack_public_path__ + "img/Studio C.83137b4f.jpg";